import * as React from 'react';
import './transaction-detail.scss';
import { Modal } from 'components/modal/modal';
import { digitSperator } from 'core/utils/decimalExtentions';
import { Badge } from 'components/badge/badge';
import { TrackOrderTransactionResult } from '../../../../../core/domain/orders-transactions/order';
import moment from 'jalali-moment';
import { Spin } from 'antd';
import { copyToClipboard } from '../../../../../core/utils/copyToClipboard';
import { CopyOutlined } from '@ant-design/icons';
import Countdown from 'antd/lib/statistic/Countdown';
import { getTransactionDetailById } from 'core/repositories/transaction';
import { TransactionDetails, TransactionType } from 'core/domain/transaction/transaction';

interface Props {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    id: string;
}

export const TransactionDetailModal: React.FC<Props> = ({ isOpen, setIsOpen, id }) => {
    const [timer, setTimer] = React.useState<any>(0);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [transaction, setTransaction] = React.useState<TransactionDetails>();

    const fetchTransactionDetailById = async () => {
        if (isOpen == true) await getTransactionDetailById(setLoading, setTransaction, setTimer, id);
    };

    React.useEffect(() => {
        fetchTransactionDetailById();
    }, [isOpen]);

    return (
        <Modal className="pmx-order-detail" isOpen={isOpen} setIsOpen={setIsOpen}>
            {loading ? (
                <Spin spinning={loading} />
            ) : (
                transaction && (
                    <>
                        <h3>جزئیات تراکنش</h3>
                        <div className="row">
                            <span>کد پیگیری</span>
                            <p className=" en">
                                {transaction?.trackingCode}

                                <CopyOutlined onClick={() => copyToClipboard(transaction?.trackingCode, 'کد پیگیری')} />
                            </p>
                        </div>
                        <div className="row">
                            <span>مارکت</span>
                            <p className=" en">{transaction?.market?.name}</p>
                        </div>
                        <div className="row">
                            <span>مقدار</span>
                            <p>
                                {transaction?.market?.symbol === 'IRT'
                                    ? digitSperator(transaction?.amount)
                                    : transaction?.amount}
                            </p>
                        </div>

                        {transaction?.voucherCode ? (
                            <div className="row">
                                <span>کد ووچر</span>
                                <p className="en">
                                    {transaction?.voucherCode}
                                    <CopyOutlined
                                        onClick={() => copyToClipboard(transaction?.voucherCode, 'کد ووچر')}
                                    />
                                </p>
                            </div>
                        ) : (
                            <></>
                        )}
                        {transaction.voucherActivationCode ? (
                            <div className="row">
                                <span>کد فعالساز ووچر</span>
                                <p>{transaction?.voucherActivationCode}</p>
                            </div>
                        ) : (
                            <></>
                        )}
                        {/* {transaction. ? (
                            <div className="row">
                                <span>بچ نامبر</span>
                                <p className="en">
                                    {transaction.withdrawal.voucher?.batchNumber ||
                                        transaction.deposit.voucher?.batchNumber}
                                    <CopyOutlined
                                        onClick={() =>
                                            copyToClipboard(
                                                transaction.withdrawal.voucher
                                                    ?.batchNumber ||
                                                    transaction.deposit.voucher
                                                        ?.batchNumber,
                                                "بچ نامبر"
                                            )
                                        }
                                    />
                                </p>
                            </div>
                        ) : (
                            <></>
                        )} */}

                        {transaction?.bankAccount?.iBan && (
                            <div className="row copy text-overflow">
                                <span>شبا</span>
                                <p>
                                    {transaction?.bankAccount?.iBan}
                                    <CopyOutlined
                                        onClick={() => copyToClipboard(transaction?.bankAccount?.iBan, 'شبا')}
                                    />
                                </p>
                            </div>
                        )}
                        {transaction?.bankAccount?.cardNumber && (
                            <div className="row copy text-overflow">
                                <span>شماره کارت</span>
                                <p>
                                    {transaction?.bankAccount?.cardNumber}
                                    <CopyOutlined
                                        onClick={() => copyToClipboard(transaction?.bankAccount?.cardNumber, 'شبا')}
                                    />
                                </p>
                            </div>
                        )}
                        {transaction.wallet?.walletAddress && (
                            <div className="row">
                                <span>آدرس کیف پول</span>
                                <p className="en long-text">
                                    <CopyOutlined
                                        onClick={() =>
                                            copyToClipboard(transaction.wallet?.walletAddress, 'آدرس کیف پول مقصد')
                                        }
                                    />
                                    {transaction.wallet?.walletAddress}
                                </p>
                            </div>
                        )}
                        {transaction?.network?.name && (
                            <div className="row">
                                <span>شبکه</span>
                                <p className="en">{transaction?.network?.name}</p>
                            </div>
                        )}
                        {transaction?.txId && (
                            <div className="row">
                                <span>هش</span>
                                <p className="en long-text">
                                    <CopyOutlined onClick={() => copyToClipboard(transaction?.txId, 'هش تراکنش')} />
                                    {transaction?.txId}
                                </p>
                            </div>
                        )}

                        {transaction.createdBy && (
                            <div className="row">
                                <span>نام کامل کاربر</span>
                                <p>{transaction.createdBy}</p>
                            </div>
                        )}

                        <div className="row">
                            <span>نوع تراکنش</span>
                            <p>
                                {transaction?.type?.title}
                                {transaction?.type?.id == TransactionType.Deposit &&
                                    transaction?.depositIrtType &&
                                    transaction?.market?.symbol === 'IRT' &&
                                    '/' + transaction?.depositIrtType?.title}
                            </p>
                        </div>
                        <div className="row">
                            <span>تاریخ و زمان تراکنش</span>
                            <p>
                                {moment.utc(transaction?.createdAt).local().locale('fa').format('HH:mm')}
                                {' | '}
                                {moment.utc(transaction?.createdAt).local().locale('fa').format('YYYY/MM/DD')}
                            </p>
                        </div>
                        {transaction?.state?.id === 10 && (
                            <div className="row">
                                <span>زمان باقی مانده تا واریز</span>
                                <p>
                                    <Countdown value={timer} />
                                </p>
                            </div>
                        )}
                        <div className="row">
                            <span>نوع تراکنش</span>
                            <p>
                                <Badge
                                    text={transaction.type.title}
                                    type={
                                        transaction.type.id == 1
                                            ? 'success'
                                            : transaction.type.id == 2 || transaction.type.id == 6
                                                ? 'waiting'
                                                : 'error'
                                    }
                                />
                            </p>
                        </div>
                        <div className="row">
                            <span>وضعیت</span>
                            <p>
                                <Badge
                                    text={transaction.state.title}
                                    type={
                                        transaction.state.id == 2
                                            ? 'success'
                                            : transaction.state.id == 1 || transaction.state.id == 6
                                                ? 'waiting'
                                                : 'error'
                                    }
                                />
                            </p>
                        </div>
                        {transaction.description &&
                            <div className='row'>
                                <span>توضیحات</span>
                                <p>{transaction.description || '-'}</p>
                            </div>
                        }
                    </>
                )
            )}
        </Modal>
    );
};
